import React from "react";

import {
  Datagrid,
  EditButton,
  ShowButton,
  DeleteWithConfirmButton,
  FunctionField,
  Button,
  List,
  TextField,
  DateField,
  useDataProvider,
  useRefresh,
  useNotify,
  SelectField,
} from "react-admin";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import DoDisturbOffIcon from "@mui/icons-material/DoDisturbOff";
import { EmptyList } from "../../../common/components";
import { dateOptions, positionType } from "../../../utils/options";

const ISHIDDEN = "visibility";
const ListVacantPositions = () => {
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  return (
    <List
      hasCreate
      exporter={false}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="Заглавие"
          source="title"
          sortable={false}
        />
        <DateField
          label="Дата на публикуване"
          source="starting_on"
          locales={"bg"}
          options={dateOptions}
          sortable={false}
        />
        <TextField
          label="Населено място"
          source="inhabited_area"
          multiline
        />
        <SelectField
          label="Тип"
          source="type"
          choices={positionType}
        />
        <FunctionField
          label=""
          render={record =>
            `${record.is_hidden}` === "true" ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <DoDisturbOffIcon style={{ color: "#da291c", fontSize: "18px" }} />
                <Button
                  label="Покажи"
                  onClick={() => {
                    return dataProvider
                      .customRequest(
                        `vacant-positions/${record.id}/${ISHIDDEN}`,
                        { id: record.id, is_hidden: false },
                        "PUT",
                      )
                      .then(() => {
                        refresh();
                        notify("Свободните позиции са обновени!", { type: "success" });
                      })
                      .catch(error => {
                        refresh();
                        notify("Свободните позиции не са обновени!", { type: "error" });
                      });
                  }}
                />
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <DoDisturbOnIcon style={{ color: "#da291c", fontSize: "18px" }} />
                <Button
                  label="Скрий"
                  color="error"
                  onClick={() => {
                    return dataProvider
                      .customRequest(
                        `vacant-positions/${record.id}/${ISHIDDEN}`,
                        { id: record.id, is_hidden: true },
                        "PUT",
                      )
                      .then(() => {
                        refresh();
                        notify("Свободните позиции са обновени!", { type: "success" });
                      })
                      .catch(error => {
                        refresh();
                        notify("Свободните позиции не са обновени!", { type: "error" });
                      });
                  }}
                />
              </div>
            )
          }
        />
        <ShowButton />
        <EditButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};

export default ListVacantPositions;
